import { Field, useField } from "formik";
import { Form, Input } from "taltech-styleguide";
import { FeedbackMessage } from "./FeedbackMessage";
import { TTFormInputProps } from "./input.types";
import { di } from "@dirootie-core/di";
import Tooltip from "react-bootstrap/Tooltip";
import { OverlayTooltip } from "../../../components-domain/generation-domain/specifications/OverlayTooltip";
import { IconTalTech } from "../../icons";

export const InputBase = ({
  id,
  label = di.str.startCase(id),
  showLabel = true,
  showHelp = false,
  tooltipText = "",
  disabled,
  elementClass,
  renderAs,
  component = Input as any,
  ...props
}: TTFormInputProps) => {
  const [field, meta, helpers] = useField(id);
  if (props.formatter !== undefined) {
    helpers.setValue(props.formatter(field.value));
  }
  const inputProps = {
    name: id,
    component: component,
    disabled,
    renderAs,
    ...props,
  };

  showHelp = false;
  return (
    <Form.Group className={elementClass}>
      {showLabel && (
        <div className="form-label-with-icon">
          <Form.Label>{label}</Form.Label>
          {showHelp && (
          <OverlayTooltip
            data={{
              helpText: tooltipText,
            }}
            component={HelpTooltip}
          >
            <IconTalTech kind="help" />
          </OverlayTooltip>
          )}
        </div>
      )}
      <Field {...inputProps} form={field} />
      <FeedbackMessage fieldId={id}></FeedbackMessage>
    </Form.Group>
  );
};

const HelpTooltip = ({ helpText }: { helpText: string }) => (
  <Tooltip style={{ position: "fixed" }}>
    <span>{helpText}</span>
  </Tooltip>
);
